import JelWorkspace from '@/store/classes/jelWorkspace';

const jelWorkspace = new JelWorkspace({
  module: 'produitCollection',
  refreshMinProd: process.env.VUE_APP_STORE_PRODUIT_COLLECTION_REFRESH_MIN,
  refreshMinDev: process.env.VUE_APP_STORE_DEV_REFRESH_MIN,
});

const state = {
  ...jelWorkspace.state,
};
const getters = {
  ...jelWorkspace.getters,

  /**
   * @param  {string} uuid
   * @return {object} Titre de la collection | null
   */
  getTitreByUuid: (state) => (uuid) => {
    const produitCollection = state.liste
      ? state.liste.find((unElement) => unElement['@id'] == uuid)
      : null;

    if (!produitCollection) {
      // Ne devrait pas arriver
      console.warn('uuid ProduitCollection inexistant', uuid);
      return null;
    }
    return produitCollection.titreCollectionFr;
  },

  /**
   * @param  {string} uuid
   * @return {object} Élément de la liste | null
   */
  getByUuid: (state, getters, rootState, rootGetters) => (uuid) => {
    const produitCollection = state.liste
      ? state.liste.find((unElement) => unElement['@id'] == uuid)
      : null;

    if (!produitCollection) {
      // Ne devrait pas arriver
      console.warn('uuid ProduitCollection inexistant', uuid);
      return null;
    }

    // L'ajout des propriétés qui suivent aide à la performance lorsqu'on filtre sur tous les produits

    // Critères généraux
    const hasCritereGeneral =
      produitCollection.titreJeuFr ||
      produitCollection.titreJeuEn ||
      produitCollection.miseIntervalleMin ||
      produitCollection.miseIntervalleMax ||
      produitCollection.lanceDepuis ||
      produitCollection.indJoueRecemment ||
      produitCollection.indFavori;

    // Critères Produits Casino
    const hasListeCategorie =
      produitCollection.listeCategorie && produitCollection.listeCategorie.length > 0;
    const hasListeEtiquette =
      produitCollection.listeEtiquette && produitCollection.listeEtiquette.length > 0;
    const hasListeFournisseur =
      produitCollection.listeFournisseur && produitCollection.listeFournisseur.length > 0;
    const hasListeProgressif =
      produitCollection.listeProgressif && produitCollection.listeProgressif.length > 0;
    const hasDisponibilite =
      produitCollection.indEnCasino == 'true' ||
      produitCollection.indOffertSalonJeux == 'true' ||
      produitCollection.indVideoPoker == 'true' ||
      produitCollection.indOffertDetaillant == 'true' ||
      produitCollection.achatGroupe == 'true';
    const hasCaracteristique =
      produitCollection.indPartieGratuite == 'true' ||
      produitCollection.indRondeBoni == 'true' ||
      produitCollection.indMultiplicateur == 'true' ||
      produitCollection.indArgentBoni == 'true' ||
      produitCollection.indBoutonStop == 'true' ||
      produitCollection.indScratch == 'true' ||
      produitCollection.indMegadrop == 'true';
    const hasCritereProduitCasino =
      hasListeCategorie ||
      hasListeEtiquette ||
      hasListeFournisseur ||
      produitCollection.indProgressif ||
      hasListeProgressif ||
      produitCollection.typeJeu ||
      hasDisponibilite ||
      hasCaracteristique;

    // Critères Produits CED (Produit Casino a préséance)
    let hasCritereProduitCED = false;
    if (!hasCritereProduitCasino) {
      // TODO: CED
      hasCritereProduitCED =
        produitCollection.idFamille ||
        produitCollection.indTableOuvert ||
        produitCollection.indTableBientotOuvert ||
        produitCollection.indTableFerme ||
        produitCollection.presentateur;
    }

    // Liste de produits
    const hasListeProduit =
      produitCollection.listeProduit && produitCollection.listeProduit.length > 0;

    return {
      ...produitCollection,
      hasCritereGeneral,
      hasCritereProduitCasino,
      hasListeEtiquette,
      hasListeCategorie,
      hasListeFournisseur,
      hasListeProgressif,
      hasDisponibilite,
      hasCaracteristique,
      hasCritereProduitCED,
      hasListeProduit,
    };
  },

  // Retourne un array trié/filtré de Produits par idProduitCollection
  getArrayProduitByUuidProduitCollection:
    (state, getters, rootState, rootGetters) => (uuidProduitCollection) => {
      const produitCollection = getters.getByUuid(uuidProduitCollection);

      if (!produitCollection) {
        return null;
      }

      if (produitCollection.idFamille) {
        return rootGetters['cedTable/getArrayProduitByProduitCollection'](produitCollection);
      }

      return rootGetters['produitCasino/getArrayProduitByProduitCollection'](produitCollection);
    },
};
const actions = {
  ...jelWorkspace.actions,
};
const mutations = {
  ...jelWorkspace.mutations,
  async INIT(state) {
    if (!state.isLoaded) {
      this.commit(`${state.module}/INTERNAL_INIT`);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
